@let futureWorkTimeStats = futureWorkTimeStats$ | async;
<wilson-working-time-section-wrapper
  [title]="'page.working_time.working_time_overview' | translate"
  [isLoading]="
    worktimeStats().length === 0 &&
    futureWorkTimeStats === null &&
    (loadingWorktimeStatsSignal() || loadingFutureWorkTimeStatsSignal())
  "
>
  @if (worktimeStats().length === 0 && futureWorkTimeStats === null) {
    <ion-label class="ion-padding">
      {{ 'general.n/a' | translate }}
    </ion-label>
  } @else {
    <ion-col size="6">
      <wilson-worktime-metrics-card
        [header]="
          ('worktime-data.is-worktime' | translate) +
          ' / ' +
          ('worktime-data.planned-hours' | translate)
        "
        [values]="worktimeStats()"
        [unit]="PayrollUnitName.Hour"
        [loading]="loadingWorktimeStatsSignal()"
      />
    </ion-col>
    @if (monthYear() === currentMonth && futureWorkTimeStats !== null) {
      <ion-col size="6">
        <wilson-worktime-metrics-card
          [header]="'page.working_time.future.title' | translate"
          [values]="[futureWorkTimeStats]"
          [unit]="PayrollUnitName.Hour"
          [loading]="loadingFutureWorkTimeStatsSignal()"
        />
      </ion-col>
    }
  }
</wilson-working-time-section-wrapper>
